import profile from "./profile";
import subscription from "./subscription";

export default {
  Profile: profile,
  Subscription: subscription,
};
